import { SITE_URL } from "../settings";

export function urlFormat(title: string) {
    return title.split(" ").join("-");
}

type Doc = {
    id: number;
    name: string;
};
type EBook = {
    id: number;
    title: string;
}
type Page = {
    id: number;
    name: string;
};
type Tag = {
    id: number;
    name: string;
};

export function pageUrl(doc: Doc, page: Page, includeSiteUrl: boolean = false) {
    const d = `${urlFormat(doc.name)}`;
    const p = `${urlFormat(page.name)}`;

    let url = includeSiteUrl ? SITE_URL : "/app/";
    url += `r-${doc.id}-${page.id}/${d}/${p}/`;
    return url;
}

export function pageShareUrl(doc: Doc, page: Page) {
    return `${SITE_URL}r-${doc.id}-${page.id}/`;
}

export function docUrl(doc: Doc, includeSiteUrl = false) {
    let url = includeSiteUrl ? SITE_URL : "/app/";
    url += `b-${doc.id}-${encodeURIComponent(urlFormat(doc.name))}/`;
    return url;
}

export function ebookUrl(ebook: EBook, includeSiteUrl = false) {
    let url = includeSiteUrl ? SITE_URL : "/";
    url += `e-${ebook.id}-${encodeURIComponent(urlFormat(ebook.title))}/`;
    return url;
}

export function docShareUrl(doc: Doc) {
    return `${SITE_URL}b-${doc.id}-/`;
}

export function tagUrl(tag: Tag, includeSiteUrl: boolean = false) {
    let url = includeSiteUrl ? SITE_URL : "/app/";
    url += `t-${tag.id}-${urlFormat(tag.name)}/`;
    return url;
}
